/* jshint esversion: 6, -W097 */
/* globals module */
"use strict";

flatPageHtmlDirective.$inject = ['$compile', 'AnalyticsService', 'SolarService'];
function flatPageHtmlDirective($compile, AnalyticsService, SolarService) {
    return {
        restrict: 'E',
        scope: {
            content: '='
        },
        link: function (scope, element, attrs) {
            const template = $compile(scope.content)(scope);
            element.replaceWith(template);
            scope.openSolarWidget = (location='flat page', product=null, shouldShowDisclosure=true, projectType=_pub.PROJECT_TYPE_SOLAR) => {
                AnalyticsService.reportEvent('Promo Clicked', {
                    type: projectType.replace('_', ' '),
                    location: location,
                });
                SolarService.goToSolar(location, product, shouldShowDisclosure, projectType);
            };
        }
    };
}

module.exports = flatPageHtmlDirective;
